<template>
    <section id="thumbnails">
        <article v-for="(item, index) in items" v-bind:class="{ 'active': activeIndex == index }">
            <a class="thumbnail" v-on:click="selectImage(item, index)">
                <img v-bind:src="item.imgix_url" alt="" />
            </a>
            <h2>{{ item.title }}</h2>
            <div v-html="item.content"></div>
        </article>
    </section>
</template>

<script>
    import {EventBus} from  './event_bus'

export default {
    name: 'thumbs',
    created() {
        this.items = [
            {'imgix_url': 'static/gallery/DSC_6067.jpg'},
            {'imgix_url': 'static/gallery/DSC_6085.jpg'},
            {'imgix_url': 'static/gallery/DSC_6096.jpg'},
            {'imgix_url': 'static/gallery/DSC_6100.jpg'},
            {'imgix_url': 'static/gallery/DSC_6105.jpg'},
            {'imgix_url': 'static/gallery/DSC_6106.jpg'},
            {'imgix_url': 'static/gallery/DSC_6107.jpg'},
            {'imgix_url': 'static/gallery/DSC_6109.jpg'},
            {'imgix_url': 'static/gallery/DSC_6110.jpg'},
            {'imgix_url': 'static/gallery/DSC_6111.jpg'},
            {'imgix_url': 'static/gallery/DSC_6112.jpg'},
            {'imgix_url': 'static/gallery/DSC_6113.jpg'},
            {'imgix_url': 'static/gallery/DSC_6116.jpg'},
            {'imgix_url': 'static/gallery/DSC_6121.jpg'},
            {'imgix_url': 'static/gallery/DSC_6122.jpg'},
            {'imgix_url': 'static/gallery/DSC_6123.jpg'},
            {'imgix_url': 'static/gallery/DSC_6126.jpg'},
            {'imgix_url': 'static/gallery/DSC_6127.jpg'},
            {'imgix_url': 'static/gallery/DSC_6128.jpg'},
            {'imgix_url': 'static/gallery/DSC_6129.jpg'},
            {'imgix_url': 'static/gallery/DSC_6131.jpg'},
            {'imgix_url': 'static/gallery/DSC_6132.jpg'},
            {'imgix_url': 'static/gallery/DSC_6134.jpg'},
            {'imgix_url': 'static/gallery/DSC_6142.jpg'},
            {'imgix_url': 'static/gallery/DSC_6146.jpg'},
            {'imgix_url': 'static/gallery/DSC_6147.jpg'},
            {'imgix_url': 'static/gallery/DSC_6152.jpg'},
            {'imgix_url': 'static/gallery/DSC_6154.jpg'},
            {'imgix_url': 'static/gallery/DSC_6159.jpg'},
            {'imgix_url': 'static/gallery/DSC_6161.jpg'},
            {'imgix_url': 'static/gallery/DSC_6169.jpg'},
            {'imgix_url': 'static/gallery/DSC_6171.jpg'},
            {'imgix_url': 'static/gallery/DSC_6173.jpg'},
            {'imgix_url': 'static/gallery/DSC_6176.jpg'},
            {'imgix_url': 'static/gallery/DSC_6181.jpg'},
            {'imgix_url': 'static/gallery/DSC_6182.jpg'},
            {'imgix_url': 'static/gallery/DSC_6184.jpg'},
            {'imgix_url': 'static/gallery/DSC_6185.jpg'},
            {'imgix_url': 'static/gallery/DSC_6186.jpg'},
            {'imgix_url': 'static/gallery/DSC_6187.jpg'},
            {'imgix_url': 'static/gallery/DSC_6188.jpg'},
            {'imgix_url': 'static/gallery/DSC_6189.jpg'},
            {'imgix_url': 'static/gallery/DSC_6190.jpg'},
            {'imgix_url': 'static/gallery/DSC_6191.jpg'},
            {'imgix_url': 'static/gallery/DSC_6192.jpg'},
            {'imgix_url': 'static/gallery/DSC_6195.jpg'},
            {'imgix_url': 'static/gallery/DSC_6196.jpg'},
            {'imgix_url': 'static/gallery/DSC_6203.jpg'},
        ];

        EventBus.$on('move', (dir) => {
            this.activeIndex = this.activeIndex + dir;
            if (dir > 0 && this.activeIndex >= this.items.length) {
                this.activeIndex = 0;
            }
            if (dir < 0 && this.activeIndex < 0) {
                this.activeIndex = this.items.length - 1;
            }
            EventBus.$emit('loaded', this.items[this.activeIndex]);
        });

        console.log('th_em', this.items);
    },
    data () {
        return {
            items: [],
            activeIndex: 0
        }
    },
    methods: {
        selectImage (itm, index) {
            EventBus.$emit('loaded', itm);
            this.activeIndex = index;
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/gallery/Thumbs.vue?31a046a4